import getMatchingVariant from '../utils/variants/getMatchingVariant';
import updatePrice from '../utils/variants/updatePrice';
import getSellingPlanPrice from '../utils/product/getSellingPlanPrice';
import updateWishlistButton from '../utils/product/updateWishlistBtn';
import updateSelectedVariant from '../utils/variants/updateSelectedVariants';
import updateFormControls from '../utils/variants/updateFormControls';
import updateURL from '../utils/variants/updateURL';
import preselectVariant from '../utils/variants/preselectVariant';
import updateVariantImages from '../utils/variants/updateVariantImages';
import updateProductGallery, { initGalleryProtection } from '../utils/product/updateProductGallery';

const initProductVariants = (container = document.querySelector('[data-product-main]')) => {
  initGalleryProtection();

  const variantEls = container.querySelectorAll('[data-variant-input]');
  const sellingPlanEls = container.querySelectorAll('[data-selling-plan-radio]');
  if (!variantEls.length && !sellingPlanEls.length) return;

  const form = container.querySelector('[data-product-form]');
  if (!form) return;

  const variantsDataEl = form.querySelector('[data-product-variants-json]');
  const optionNamesEl = form.querySelector('[data-product-options-json]');
  const variantInventoryEl = form.querySelector('[data-product-variants-inventory-policy-json]');
  const isBundleEl = form.querySelector('[data-product-is-bundle]');
  const variantIdInput = form.querySelector('[data-atc-id-input]');
  const sellingPlanGroupContainerEl = form.querySelector('[data-selling-plan-groups]');
  const sellingPlanIdInput = sellingPlanGroupContainerEl?.querySelector('[data-selling-plan-input]');
  const quantitySelector = form.querySelector('[data-quantity-selector]');
  const quantityInput = quantitySelector?.querySelector('[data-quantity-input]');
  const atcButton = form.querySelector('button[type="submit"]');
  const atcButtonPrice = atcButton?.querySelector('[data-atc-price]');
  const atcButtonMsg = atcButton?.querySelector('[data-atc-price-msg]');
  const atcButtonPipe = atcButton?.querySelector('[data-atc-price-pipe]');
  const productPreOrderMsg = container.querySelector('[data-product-preorder-msg]');
  const productSoldInfo = container.querySelector('[data-product-sold-info]');
  const productControls = container.querySelector('[data-product-controls]');
  const klaviyoBIS = container.querySelector('[data-klaviyo-bis]');
  let wishlistButton = container.querySelector('[data-smart-wishlist-button]');

  let variantsData = [];
  let optionNames = [];
  let variantInventory = [];
  let isBundleProduct = false;

  try {
    variantsData = JSON.parse(variantsDataEl?.textContent || '[]');
    optionNames = JSON.parse(optionNamesEl?.textContent || '[]');
    variantInventory = JSON.parse(variantInventoryEl?.textContent || '[]');
    isBundleProduct = JSON.parse(isBundleEl?.textContent || 'false') === true;
  } catch (e) {
    console.error('Invalid variant/options JSON', e);
    return;
  }

  const selectedOptions = {};
  const urlHadVariantOnLoad = new URL(window.location.href).searchParams.has('variant');

  const isPopup = document.querySelector('[data-atc-popup]')?.open === true;
  const priceContainer = document.querySelector(
    isPopup ? '[data-product-price-popup]' : '[data-product-price-pdp]'
  );
  const priceEl = priceContainer?.querySelector('[data-product-price]');
  const compareAtPriceEl = priceContainer?.querySelector('[data-product-compare-at-price]');
  const badgeEl = priceContainer?.querySelector('[data-product-sale-badge]');

  const updateVariantDetails = () => {
    const variant = getMatchingVariant(selectedOptions, variantsData, optionNames);
    if (!variant) return;

    variantIdInput && (variantIdInput.value = variant.id);
    updatePrice({
      priceEl,
      compareAtPriceEl,
      badgeEl,
      price: getSellingPlanPrice(variant, sellingPlanIdInput?.value, 'price'),
      compareAtPrice: getSellingPlanPrice(variant, sellingPlanIdInput?.value, 'compare_at_price'),
      badgeTemplate: window.theme.strings.priceBadgeText
    });

    if (!isPopup) {
      updateSelectedVariant({
        variant,
        variantInventory,
        isBundleProduct,
        elements: {
          productPreOrderMsg,
          productSoldInfo,
          productControls,
          klaviyoBIS,
          atcButtonMsg
        },
        strings: window.theme.strings
      });

      updateURL({ variantID: variant.id, sellingPlanIdInput });
      wishlistButton = updateWishlistButton(wishlistButton, variant.id);
      if (!variant.available) {
        klaviyoBIS.dataset.unavailableVariantId = variant.id;
      }
    }

    updateFormControls({
      variant,
      qty: quantityInput ? +quantityInput.value : 1,
      variantsData,
      optionNames,
      selectedOptions,
      atcButton,
      atcButtonPrice,
      atcButtonPipe,
      quantitySelector,
      sellingPlanId: sellingPlanIdInput?.value,
      getSellingPlanPrice
    });

    if (window.__kashGalleryEnabled || urlHadVariantOnLoad) {
      updateProductGallery(variant);
    }
    updateVariantImages(selectedOptions, variantsData, optionNames);

    container.querySelectorAll('[data-selected-option-label]').forEach(el => {
      const value = selectedOptions[el.dataset.selectedOptionLabel];
      if (value) el.textContent = value;
    });
  };

  const updateSelectedOption = (name, value) => {
    selectedOptions[name] = value;
    updateVariantDetails();
  };

  if (variantEls.length) {
    variantEls.forEach(variant => {
      variant.addEventListener('change', (event) => {
        const { name, value } = event.target;
        if (event.isTrusted) window.__kashGalleryEnabled = true;
        updateSelectedOption(name, value);
        if (event.isTrusted) window.__kashGalleryEnabled = false;
      });
    });
  }

  preselectVariant({
    variantsData,
    optionNames,
    form,
    selectedOptions,
    updateSelectedOption,
    updateVariantDetails,
    variantIdInput
  });
};

export default initProductVariants;
